import LoadingSpinner from "@/components/common/LoadingSpinner";
import { CustomChildTable } from "@/components/CustomChildTable";
import { CustomImageUpload } from "@/components/CustomImageUpload";
import { CustomFileUpload } from "@/components/CustomFileUpload";
import { get } from "@/services/axiosUitils";
import {
  Checkbox,
  DatePicker,
  FormGrid,
  FormItem,
  FormLayout,
  FormTab,
  Input,
  NumberPicker,
  Password,
  Radio,
  Select,
  Switch,
  TimePicker,
  TreeSelect,
} from "@formily/antd-v5";
import { createSchemaField, FormProvider } from "@formily/react";
import {
  Card,
  Cascader,
  InputNumber,
  Rate,
  Slider,
  Tabs,
  Transfer,
} from "antd";
import TextArea from "antd/es/input/TextArea";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

import { translateSchemaDeep } from "@/lib/translateSchemaDeep";
import GoogleAddressInput from "@/components/GoogleAddressInput";

const Text = ({ value, content, mode = "span", style = {}, ...props }: any) => {
  const Tag = mode ?? "span";
  return (
    <Tag style={style} {...props}>
      {content ?? value}
    </Tag>
  );
};

const SchemaField = createSchemaField({
  components: {
    FormItem,
    Input,
    NumberPicker,
    Password,
    Select,
    Checkbox,
    DatePicker,
    Switch,
    Radio,
    CustomFileUpload,
    GoogleAddressInput,
    CustomImageUpload,
    FormLayout,
    Card,
    FormGrid,
    FormTab,
    Tabs,
    InputNumber,
    TreeSelect,
    TimePicker,
    Cascader,
    Transfer,
    Slider,
    Rate,
    TextArea,
    CustomChildTable,
    Text,
    ReactQuill,
  },
});

const SchemaFormRender = ({ schemaJson, form }: any) => {
  const { t } = useTranslation();

  // Move hooks before any early returns
  const [translatedSchema, setTranslatedSchema] = useState(() => {
    if (!schemaJson) {
      return null;
    }
    const schema = schemaJson.schema ?? schemaJson;
    return translateSchemaDeep(schema, t, "common");
  });

  const useAsyncDataSource =
    (service: (arg0: any) => Promise<any>, doc: any) => (field: any) => {
      field.loading = true;
      service(doc).then((data: any) => {
        field.dataSource = data;
        field.loading = false;
      });
    };

  const getOptions = async (schemaName: string) => {
    const data = await getOptionsApiCall(schemaName);
    return data;
  };

  async function getOptionsApiCall(schemaName: string) {
    return await get(`/dropdown/${schemaName}/`);
  }

  // const fetchOptions = async (url: string) => {
  //   const data = await get(url);
  //   return Array.isArray(data) ? data : (data?.results ?? []);
  // };

  useEffect(() => {
    if (schemaJson) {
      const schema = schemaJson.schema ?? schemaJson;
      setTranslatedSchema(translateSchemaDeep(schema, t, "common"));
    }
  }, [schemaJson, t]);

  if (!schemaJson) {
    return (
      <div className="flex h-screen items-center justify-center">
        <LoadingSpinner />
      </div>
    );
  }

  const layoutProps = schemaJson.form ?? {};

  return (
    <FormProvider form={form}>
      <FormLayout {...layoutProps}>
        <SchemaField
          schema={translatedSchema}
          scope={{
            useAsyncDataSource,
            getOptions,
            t,
          }}
        />
      </FormLayout>
    </FormProvider>
  );
};

export default SchemaFormRender;
